import { useJournals } from '../../../queries/use-journals';
import { ReconciliationWorksheet } from '../../../types/worksheet';
import PreviewSection from '../PreviewSection';
import JournalPreview from './JournalPreview';

type JournalsPreviewProps = {
    worksheet: ReconciliationWorksheet;
};

function JournalsPreview({ worksheet }: JournalsPreviewProps): JSX.Element {
    const journalsQuery = useJournals(worksheet.workpaperId, { filter: `accounts=${worksheet.account.id}` });

    const count = worksheet.journals?.length ?? 0;

    if (journalsQuery.isLoading) {
        return <></>;
    }

    if (!journalsQuery.isSuccess) {
        return <></>;
    }

    const journals = journalsQuery.data.journals ?? [];

    return (
        <PreviewSection title={`Journals (${count})`}>
            {journals.length > 0 && (
                <div className="grid grid-cols-6 border border-gray-200 rounded-t-md overflow-hidden mt-2">
                    <div className="grid grid-cols-[subgrid] col-span-full bg-gray-50 h-8 items-center text-gray-600 text-sm font-medium px-4 gap-8">
                        <p className="col-span-3">Journal</p>
                        <p className="text-right col-span-2">Account</p>
                        <p></p>
                    </div>

                    {journals.map((journal) => {
                        return <JournalPreview key={journal.id} journal={journal} worksheet={worksheet} />;
                    })}
                </div>
            )}
        </PreviewSection>
    );
}

export default JournalsPreview;
